export default {
  en: {
    title: 'Practise spoken English with an AI tutor',
    body: 'A trainer for real spoken English — 10 times cheaper than lessons with a tutor.',
    perk: {
      voice: 'Voice conversations',
      mistakes: 'Mistake review',
      topics: 'Ready-made topics',
      vocabulary: 'Word lists with review',
      level: 'Level check',
      stats: 'Full statistics',
      personal: 'Personalisation',
      reminders: 'Reminders',
      history: 'Conversation history',
    },
    previewTutor: 'Ryan, your English tutor',
    previewYou: 'You, by voice',
    start: 'Try it free',
    startNote: 'No card needed',
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
    telegram: 'Continue in Telegram',
    offer: 'Terms',
    privacy: 'Privacy policy',
  },
  ru: {
    // Неразрывные дефисы (U+2011): иначе строка рвалась на «ИИ-/репетитором».
    title: 'Практикуй разговорный английский с ИИ‑репетитором',
    // Та же формулировка, что на лендинге (`website/src/app/page.tsx`).
    // Неразрывный пробел перед тире — иначе тире начинало строку.
    body: 'Тренажёр живого разговорного английского — в 10 раз дешевле занятий с репетитором.',
    perk: {
      voice: 'Голосовые диалоги',
      mistakes: 'Разбор ошибок',
      topics: 'Заготовленные темы',
      vocabulary: 'Словари с повторением',
      level: 'Проверка уровня',
      stats: 'Полная статистика',
      personal: 'Персонализация',
      reminders: 'Напоминания',
      history: 'История разговоров',
    },
    previewTutor: 'Ryan, репетитор английского',
    previewYou: 'Ты, голосом',
    start: 'Попробовать бесплатно',
    // Регистрации тоже не надо до 3-й реплики, но «без регистрации» обещало бы
    // больше, чем есть (дальше вход, `GUEST_FREE_TURNS`).
    startNote: 'Карта не нужна',
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
    telegram: 'Продолжить в Telegram',
    offer: 'Оферта',
    privacy: 'Политика конфиденциальности',
  },
};
